import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './global.css'
import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://6b81bf1ab02c80572594597c914244b5@o4506514324848640.ingest.us.sentry.io/4510416653320192',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
